import { combineReducers } from 'redux';
import App from './app/reducer';
import Auth from './auth/reducer';
import Calendar from './calendar/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
import Drawer from './drawer/reducer';
import Modal from './modal/reducer';
import Profile from './profile/reducer';
import techReportReducer from '../../Sleep/redux/techReport/reducer';

export default combineReducers({
  Auth,
  App,
  ThemeSwitcher,
  LanguageSwitcher,
  Calendar,
  Modal,
  Drawer,
  Profile,
  TechReport: techReportReducer,
});
